export default __webpack_public_path__ + "static/media/dieppemini.f9df2701.jpg";